import { useEffect, useState } from "react";
import { api } from "@/api";
import { useAutenticacao } from "@/contextos/AutenticacaoContexto";
import { LayoutAutenticado } from "@/componentes/LayoutAutenticado";
import { Trophy, Target, Calendar, Wallet } from "lucide-react";
import { Link } from "react-router-dom";

export default function DashboardApostador() {
  const { usuario } = useAutenticacao();
  const [dash, setDash] = useState({});
  const [proximos, setProximos] = useState([]);

  useEffect(() => {
    (async () => {
      const [d, p] = await Promise.all([
        api.get("/dashboard/apostador").catch(() => ({ data: {} })),
        api.get("/publico/proximos-jogos", { params: { limit: 3 } }).catch(() => ({ data: [] })),
      ]);
      setDash(d.data || {});
      setProximos(p.data || []);
    })();
  }, []);

  const rk = dash.ranking || {};
  const pag = dash.pagamento || {};

  return (
    <LayoutAutenticado>
      <div data-testid="dashboard-apostador">
        <div className="mb-8">
          <div className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Visão Geral</div>
          <h1 className="font-heading text-4xl font-bold uppercase mt-1">Olá, {usuario?.nomePublico || usuario?.nomeCompleto?.split(" ")[0]}</h1>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
          <Tile titulo="Posição" valor={rk.posicaoAtual ?? "—"} prefixo="#" icone={Trophy} />
          <Tile titulo="Pontuação" valor={rk.pontuacaoTotal ?? 0} icone={Target} cor="amarelo" />
          <Tile titulo="Palpites" valor={dash.totalPalpites ?? 0} icone={Calendar} />
          <Tile
            titulo="Pagamento"
            valor={pag.statusPagamento === "PAGO" ? "PAGO" : "PENDENTE"}
            icone={Wallet}
            cor={pag.statusPagamento === "PAGO" ? "verde" : "red"}
            small
          />
        </div>

        {pag.statusPagamento !== "PAGO" && (
          <div className="surface-card rounded-2xl p-6 border-amarelobrasil/30 mb-8 flex items-center justify-between" data-testid="aviso-pagamento">
            <div>
              <div className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Atenção</div>
              <div className="font-heading text-xl font-bold mt-1">Seu pagamento está pendente</div>
              <p className="text-sm text-white/60 mt-1">Regularize com a administração para liberar os palpites.</p>
            </div>
          </div>
        )}

        <section className="mb-10">
          <div className="flex items-end justify-between mb-4">
            <h2 className="font-heading text-2xl font-bold uppercase">Próximos jogos</h2>
            <Link to="/palpitar" className="text-xs font-bold uppercase tracking-widest text-amarelobrasil hover:text-white" data-testid="link-palpitar">
              Palpitar agora →
            </Link>
          </div>
          {proximos.length === 0 ? (
            <div className="text-white/40 text-sm">Nenhum jogo agendado.</div>
          ) : (
            <div className="grid md:grid-cols-3 gap-4">
              {proximos.map((j) => (
                <div key={j.id} className="surface-card rounded-2xl p-5">
                  <div className="text-[10px] uppercase tracking-widest text-white/40 mb-2">Rodada {j.rodada}</div>
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-bold">{j.selecaoMandante?.sigla}</span>
                    <span className="text-white/40">×</span>
                    <span className="font-bold">{j.selecaoVisitante?.sigla}</span>
                  </div>
                  <div className="text-xs text-white/60">
                    {new Date(j.dataHoraJogo).toLocaleString("pt-BR", { timeZone: "America/Sao_Paulo" })}
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>
    </LayoutAutenticado>
  );
}

function Tile({ titulo, valor, prefixo = "", icone: Icone, cor = "verde", small }) {
  const corFundo = {
    verde: "text-verdebrasil",
    amarelo: "text-amarelobrasil",
    red: "text-red-400",
  }[cor];
  return (
    <div className="surface-card rounded-2xl p-5" data-testid={`tile-${titulo.toLowerCase()}`}>
      <Icone className={`w-5 h-5 ${corFundo} mb-3`} />
      <div className={`font-heading font-black tabular-nums ${small ? "text-xl uppercase tracking-widest" : "text-4xl"}`}>
        {prefixo}{valor}
      </div>
      <div className="text-[10px] uppercase tracking-[0.25em] text-white/40 mt-1">{titulo}</div>
    </div>
  );
}
